




































import { Component, Vue } from 'vue-property-decorator';
import GameLogic, {FeedbackRecord, Hotspot, HotspotOption, HotspotOptionRecord} from "@/services/GameLogic";
import {DelierState, MoodState} from "../store/store";
import LocaleService from '@/services/LocaleService';
import Repeater from "@/components/Repeater.vue";
import Klokjes from "@/components/Klokjes.vue";
import LocaleText from '@/components/LocaleText.vue';
import FeedbackLayout from "./components/FeedbackLayout.vue";

@Component({
    components: {FeedbackLayout, Klokjes, Repeater, LocaleText},
    computed: {
        getBestPossibleScore():string {
            const situation = GameLogic.getSituationObject(this.$store.state);
            return situation.situation.score.displayMax + '';
        },
        endDayRoute():string {
            // TODO
            return '/day/' + (this.$store.state.day + 1) + '';
        },
        getConclusie():string {
            let situation = GameLogic.getSituationObject(this.$store.state);
            const key:string = [situation.situation.name, '.evaluatie.',
                MoodState[this.$store.state.mood]].join('');
            //console.log(key);
            return LocaleService.getValue(this.$store.state, key);
        },
        getScoreText():string {
            const situation = GameLogic.getSituationObject(this.$store.state);
            let fmt:string = LocaleService.getValue(this.$store.state, "algemeen.evaluatiescherm.score.text");
            fmt = fmt.replace('{0}', situation.situation.score.displayMax + '')
                .replace('{1}', this.$store.state.dayState.score + '')
                ;//.replace('\n', '<br />');
            return fmt;
}
    },
    methods: {
        handleClose(): void {
            //GameLogic.nextDay(this.$router, this.$store);
            this.$router.push(['/night/', this.$store.state.day].join(''));
        },
        getTip(record:HotspotOptionRecord):string {
            return LocaleService.optionFeedbackInactief(this.$store.state, record.hotspot.name, record.option.name);
        },
        getHotspotName(record:HotspotOptionRecord):string {
            return LocaleService.hotspotDisplayName(this.$store.state, record.hotspot.name);
        },
        getOptionName(record:HotspotOptionRecord):string {
            return LocaleService.optionDisplayName(this.$store.state, record.hotspot.name, record.option.name);
        },
    },
    created():void {
        this.$store.commit('processPatientMood');
        GameLogic.processDayFeedback(this.$store.state);
    }
})
export default class Evaluatie extends Vue {}
